import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Radio, Button, message } from 'antd'
import api from '../../../services/api'
import { useTranslation } from 'react-i18next'

const CREDIT_OPTIONS = [
  { label: '500 Credits', value: 500, price: 50 },
  { label: '1000 Credits', value: 1000, price: 100 },
  { label: '10,000 Credits', value: 10000, price: 1000 }
]

const PurchaseCreditsModal = ({ visible, onCancel, onSuccess }) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [selectedCredits, setSelectedCredits] = useState(1000)

  const handlePurchase = async () => {
    setLoading(true)
    try {
      const option = CREDIT_OPTIONS.find(opt => opt.value === selectedCredits)
      const product_data = {
        name: option.label,
        unit_amount: option.price,
        credits: option.value
      }

      const res = await api.aiCredits.purchaseAiCredits({ product_data })
      if (res && res.data && res.data.status !== 'error') {
        if (res.data.url) {
          window.location.href = res.data.url
        } else {
          if (onSuccess) {
            onSuccess()
          }
        }
      } else {
        throw new Error((res && res.data && res.data.message) || 'Failed to purchase credits')
      }
    } catch (error) {
      message.error(error.message || 'An error occurred while purchasing credits.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title="Purchase More Credits"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handlePurchase}
        >
          Purchase
        </Button>
      ]}
    >
      <div style={{ padding: '20px 0' }}>
        <p style={{ marginBottom: 16 }}>Select the amount of credits you want to purchase:</p>
        <Radio.Group
          onChange={(e) => setSelectedCredits(e.target.value)}
          value={selectedCredits}
        >
          {CREDIT_OPTIONS.map(option => (
            <Radio
              key={option.value}
              value={option.value}
              style={{ display: 'block', height: '30px', lineHeight: '30px' }}
            >
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </div>
    </Modal>
  )
}

export default PurchaseCreditsModal
